const assets = {
  "BadgeCheck.svg": "/marketing-assets/BadgeCheck.svg",
  "Favicon_OptrixisOptrixis_Mail.svg": "/marketing-assets/Favicon_OptrixisOptrixis_Mail.svg",
  "ListChecks.svg": "/marketing-assets/ListChecks.svg",
  "Logo_Apple.svg": "/marketing-assets/Logo_Apple.svg",
  "Logo_Booking.svg": "/marketing-assets/Logo_Booking.svg",
  "Logo_Facebook.svg": "/marketing-assets/Logo_Facebook.svg",
  "Logo_Google.svg": "/marketing-assets/Logo_Google.svg",
  "Logo_Instagram.svg": "/marketing-assets/Logo_Instagram.webp",
  "Logo_Meta.svg": "/marketing-assets/Logo_Meta.webp",
  "Logo_Optrixis_v2_copie_2Optrixis_Local_Logo.svg": "/marketing-assets/Logo_Optrixis_v2_copie_2Optrixis_Local_Logo.svg",
  "Logo_Optrixis_v2_copie_4Optrixis_Local_Logo.svg": "/marketing-assets/Logo_Optrixis_v2_copie_4Optrixis_Local_Logo.svg",
  "Logo_Whatsapp.svg": "/marketing-assets/Logo_Whatsapp.webp",
  "Logo_tripadvisor.svg": "/marketing-assets/Logo_tripadvisor.webp",
  "Logo_yelp.svg": "/marketing-assets/Logo_yelp.svg",
  "MapPinCheck.svg": "/marketing-assets/MapPinCheck.svg",
  "clothing-shop_16312654.gif": "/marketing-assets/clothing-shop_16312654.webp",
  "food-delivery_11933459.gif": "/marketing-assets/food-delivery_11933459.webp",
  "hotel_14204924.gif": "/marketing-assets/hotel_14204924.webp",
  "massage_17102557.gif": "/marketing-assets/massage_17102557.webp",
  "medical-insurance_17702133.gif": "/marketing-assets/medical-insurance_17702133.webp",
} as const;

export type MarketingAssetName = keyof typeof assets;

export function asset(name: MarketingAssetName) {
  return assets[name];
}
